import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import React, {useEffect, useState} from "react";
import Home from "./pages/home/Home";
import StudentHome from "./pages/studentHome/StudentHome";
import ExaminerHome from "./pages/examinerHome/ExaminerHome";
import ProjectParticularForm from './components/addnew/ProjectParticularForm';
import ViewProjectParticular from "./components/addnew/ViewProjectParticular";
import StudentResources from "./components/addnew/StudentResources";
import Login from "./pages/login/Login";
import List from "./pages/list/List";
import Single from "./pages/single/Single";
import New from "./pages/new/New";
import {TermCourse} from "./components/mappings/TermCourse";
import PrivateRoute from "./PrivateRoute";
//import PrivateRoute from './PrivateRoute';
import { AuthProvider, useAuth } from './AuthProvider';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {




  return (
    <div className="App">
       <AuthProvider>
      <BrowserRouter>
        <Routes>
        <Route path="/login" element={<Login />}>
                    
        </Route>
        <Route  path="/student"  >
            <Route  index element={<PrivateRoute role={['ROLE_STUDENT']}  ><StudentHome /></PrivateRoute>}/> 
            <Route  path="view-submission/:submissionId" element={<PrivateRoute role={['ROLE_STUDENT']}><New type="studentsubmission"/></PrivateRoute>}/>
            <Route  path="edit-submission/:submissionId" element={<PrivateRoute role={['ROLE_STUDENT']}><New type="studentsubmission"/></PrivateRoute>}/>
            <Route  path="upload-submission/:announcementId/:report_type/:report_month" element={<PrivateRoute role={['ROLE_STUDENT']}><New type="studentsubmission"/></PrivateRoute>}/>
            <Route path="project-particular-form" element={<ProjectParticularForm />} />  
            <Route path="update-project-particular/:studentId" element={<ViewProjectParticular />} />  

              <Route  path="feedbacks" >
              <Route  index element={<PrivateRoute role={['ROLE_STUDENT']}><List type="studentFeedbacks"/></PrivateRoute>}/>
              <Route  path="view-feedback/:studentId/:feedbackId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN','ROLE_STUDENT']}><New type="feedback"/></PrivateRoute>}/>
              
              </Route >
              <Route  path="resources" >
              <Route  index element={<PrivateRoute role={['ROLE_STUDENT']}><New type="studentresource"/></PrivateRoute>}/>
              
              </Route >

              <Route  path="monthly-evaluation" >
              <Route  index element={<PrivateRoute role={['ROLE_STUDENT']}><New type="monthlyevaluation"/></PrivateRoute>}/>
              <Route  path="view-evaluation/:studentId/:feedbackId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN','ROLE_STUDENT']}><New type="viewMonthlyEvaluation"/></PrivateRoute>}/> 
              
              </Route >
          </Route>
          <Route  path="/examiner"  >
            <Route  index element={<PrivateRoute role={['ROLE_EXAMINER','ROLE_REVIEWER']}  ><ExaminerHome /></PrivateRoute>}/> 
            <Route  path="view-feedbacks/:studentId" element={<PrivateRoute role={['ROLE_EXAMINER','ROLE_REVIEWER']}><New type="viewfeedbacksexaminer"/></PrivateRoute>}/>
            {/* <Route  path="thesisAssigned" >
              <Route  index element={<PrivateRoute role={['ROLE_EXAMINER']}><List type="thesisAssigned"/></PrivateRoute>}/>
              
            </Route > */}

            <Route  path="edit-vivaSlot/:examinerId" element={<PrivateRoute role={['ROLE_EXAMINER','ROLE_REVIEWER']}><New type="vivaslot"/></PrivateRoute>}/>

          </Route>
          <Route  path="/"  >
            <Route  index element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}  ><Home /></PrivateRoute>}/>
            <Route  path="vivaslots" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="allvivaslots"/></PrivateRoute>}/> 
           
             <Route  path="students">
              <Route  index element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><List type="student"/></PrivateRoute>}/>
              <Route  path=":studentId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><Single/></PrivateRoute>}/>
              <Route  path="edit-student/:studentId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="student"/></PrivateRoute>}/>
              <Route  path="new" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New  type="student"/></PrivateRoute>}/>
            </Route >
            <Route  path="enrollments">
              <Route  index element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><List type="enrollment"/></PrivateRoute>}/>
            </Route >
            <Route  path="courses" >
              <Route  index element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><List type="course"/></PrivateRoute>}/>
              <Route  path="view-course/:courseId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="course"/></PrivateRoute>}/>
              <Route  path="edit-course/:courseId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="course"/></PrivateRoute>}/>
              <Route  path="new" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="course"/></PrivateRoute>}/>
            </Route >
            <Route  path="instructors" >
              <Route  index element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><List type="instructor"/></PrivateRoute>}/>
              <Route  path="view-instructor/:instructorId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="instructor"/></PrivateRoute>}/>
              <Route  path="edit-instructor/:instructorId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="instructor"/></PrivateRoute>}/>
              <Route  path="new" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="instructor"/></PrivateRoute>}/>
            </Route >
            <Route  path="terms" >
              <Route  index element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><List type="term"/></PrivateRoute>}/>
              <Route  path="view-term/:termId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="term"/></PrivateRoute>}/>
              <Route  path="edit-term/:termId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="term"/></PrivateRoute>}/>
              <Route  path="new" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="term"/></PrivateRoute>}/>
            </Route >

            <Route  path="termcourses" >
              <Route  index element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><TermCourse /></PrivateRoute>}/>
              <Route  path="view-termcourse/:termCourseId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="termCourse"/></PrivateRoute>}/>
              <Route  path="edit-termcourse/:termCourseId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="termCourse"/></PrivateRoute>}/>
              
            </Route >

            <Route  path="announcements" >
              <Route  index element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><List type="announcement" /></PrivateRoute>}/>
              <Route  path="view-announcement/:announcementId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="announcement"/></PrivateRoute>}/>
              <Route  path="edit-announcement/:announcementId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="announcement"/></PrivateRoute>}/>
              <Route  path="new" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="announcement"/></PrivateRoute>}/>
            
            </Route >
            <Route  path="assignexaminers" >
              <Route  index element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><List type="assignexaminer"/></PrivateRoute>}/>
              <Route  path="assignexaminer/:thesisStatusId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="assignexaminer"/></PrivateRoute>}/>
              <Route  path="view-assigned/:thesisStatusId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="assignexaminer"/></PrivateRoute>}/>

            </Route >
            <Route  path="auto-schedule-viva" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="vivaautoschedule"/></PrivateRoute>}/>

            <Route  path="assignterms" >
              {/* <Route  index element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><List type="assignterms"/></PrivateRoute>}/> */}
              <Route  index element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="assignterms"/></PrivateRoute>}/>
             
            </Route >
            <Route  path="thesis" >
              <Route  index element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><List type="thesis"/></PrivateRoute>}/>
              <Route  path="view-thesis/:thesisId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="thesis"/></PrivateRoute>}/>
              <Route  path="view-thesis-details/:id" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="thesisdetails"/></PrivateRoute>}/>
              <Route  path="edit-thesis/:thesisId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="thesis"/></PrivateRoute>}/>

            </Route >

            <Route  path="vivaConfiguration" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="vivaConfiguration"/></PrivateRoute>}/>
           
          </Route >

          
            <Route  path="lecturelinks" >
              <Route  index element={<PrivateRoute role={['ROLE_ADMIN']}><List type="lecturelink"/></PrivateRoute>}/>
              <Route  path="new" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN','ROLE_EXAMINER','ROLE_REVIEWER']}><New type="lecturelink"/></PrivateRoute>}/>
              <Route  path="view-lecturelink/:id" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN','ROLE_EXAMINER','ROLE_REVIEWER']}><New type="lecturelink"/></PrivateRoute>}/>
              <Route  path="edit-lecturelink/:id" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN','ROLE_EXAMINER','ROLE_REVIEWER']}><New type="lecturelink"/></PrivateRoute>}/>

            </Route >
            
          <Route  path="grades" >
              <Route  index element={<PrivateRoute role={['ROLE_ADMIN']}><List type="grade"/></PrivateRoute>}/>
              <Route  path="edit-grades/:thesisStatusId" element={<PrivateRoute role={['ROLE_ADMIN']}><New type="grade"/></PrivateRoute>}/>
              
          </Route>

          <Route  path="feedbacks" >
              <Route  index element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN', 'ROLE_EXAMINER','ROLE_REVIEWER']}><List type="feedback"/></PrivateRoute>}/>
              <Route  path="view-feedback/:feedbackId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN','ROLE_EXAMINER','ROLE_REVIEWER']}><New type="feedback"/></PrivateRoute>}/>
              <Route  path="view-feedback/:studentId/:feedbackId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN','ROLE_EXAMINER','ROLE_REVIEWER']}><New type="feedback"/></PrivateRoute>}/>
              
              <Route  path="edit-feedback/:feedbackId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN','ROLE_EXAMINER','ROLE_REVIEWER']}><New type="feedback"/></PrivateRoute>}/>
              <Route  path="new" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN','ROLE_EXAMINER','ROLE_REVIEWER']}><New type="feedback"/></PrivateRoute>}/>
              <Route  path="newe/:thesisStatusId" element={<PrivateRoute role={['ROLE_EXAMINER','ROLE_REVIEWER']}><New type="feedbacke"/></PrivateRoute>}/>
            </Route >

            <Route  path="studentrequests" >
              <Route  index element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><List type="studentrequest"/></PrivateRoute>}/>
              <Route  path="view-studentrequest/:studentRequestId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="studentrequest"/></PrivateRoute>}/>
              <Route  path="edit-studentrequest/:studentRequestId" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="studentrequest"/></PrivateRoute>}/>
              <Route  path="new" element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="studentrequest"/></PrivateRoute>}/>
            </Route >

            <Route  path="mailcommunication" >
              <Route  index element={<PrivateRoute role={['ROLE_USER', 'ROLE_ADMIN']}><New type="mailcommunication"/></PrivateRoute>}/>
            </Route >
          
        </Routes>
      </BrowserRouter>
      </AuthProvider>
      <ToastContainer />
    </div>
  );
}

export default App;
